export const ambassadorWithHeaders = (httpClient, controllerConfig, currency) => {
  const currencyHeader = currency ? {
    'x-wix-currency': currency
  } : {};
  const multilingualHeader = getMultilingualHeader(controllerConfig);
  const params = {
    headers: {
      ...currencyHeader,
      ...multilingualHeader
    }
  };
  return req => {
    return httpClient.request(args => ({
      ...req(args),
      ...params
    }));
  };
};
const getMultilingualHeader = controllerConfig => {
  const {
    multilingual
  } = controllerConfig.wixCodeApi.window;
  if (!(multilingual != null && multilingual.isEnabled)) {
    return {};
  }
  const currentLanguage = multilingual.siteLanguages.find(lang => lang.languageCode === multilingual.currentLanguage);
  if (!currentLanguage) {
    return {};
  }
  return {
    'x-wix-linguist': `${currentLanguage.languageCode}|${currentLanguage.locale}|${currentLanguage.isPrimaryLanguage.toString()}|${controllerConfig.appParams.instanceId}`
  };
};
//# sourceMappingURL=ambassador.utils.js.map